import React from "react";

const Sales = () => {
  return <div><h1>Work In Progress......</h1></div>;
};

export default Sales;
